module.exports = __webpack_public_path__ + "img/rnd1.4140cef2.jpg";